/**
 * @fileoverview Models for receiving data about alternate brand name configurations for use in
 * the Specify Listings Settings Page.
 *
 * This is adapted from ListingsStorm2.
 *
 * @author Heesun Jun (hjun@yext.com)
 */

import {unescapeEntities} from 'goog:goog.string';

export class AltBrandNamesConfig {
  /**
   * @param {{
   *  id: string,
   *  name: string,
   *  description: (string | undefined),
   * }} params
   */
  constructor(params) {
    /** @type {string} */
    this.id = params.id;
    /** @type {string} */
    this.name = params.name;
    /** @type {(string | undefined)} */
    this.description = params.description;
  }

  /**
   * @param {!AltBrandNamesConfigJson} json
   * @return {!AltBrandNamesConfig}
   */
  static fromJSON(json) {
    return new AltBrandNamesConfig({
      id: json['id'],
      name: unescapeEntities(json['name']),
      description: unescapeEntities(json['description']),
    });
  }

  /** @return {!AltBrandNamesConfigJson} */
  toJSON() {
    return {
      'id': this.id,
      'name': this.name,
      'description': this.description ?? '',
    };
  }
}

/**
 * @dict
 * @typedef {{
 *  id: string,
 *  name: string,
 *  description: string,
 * }}
 */
export var AltBrandNamesConfigJson;
